// クラウド変数を一時的に保持する
import API from '../../api'
import Vue from 'vue'
import { callApiWithRefresh } from '../../api/util'

// TODO: LRUでcache化する
const state = {
    coupon_now: null
}

const mutations = {
    updateStoreCoupon(state, payload) {
        Vue.set(state, "coupon_now", payload)
    }
}

const actions = {
    //store部分
    updateStoreCoupon(ctx, uAction) {
        ctx.commit('updateStoreCoupon', uAction)
    },

    //APIとの通信部分
    showCoupons(ctx) {
        return callApiWithRefresh(
            () => ctx.rootState.account.accessToken,
            () => ctx.dispatch('account/_refreshToken', null, { root: true }),
            (token) => API.showCoupons(token)
        )
    },
    showCoupon(ctx, couponId) {
        return callApiWithRefresh(
            () => ctx.rootState.account.accessToken,
            () => ctx.dispatch('account/_refreshToken', null, { root: true }),
            (token) => API.showCoupon(token, couponId)
        )
    },
    getCoupon(ctx) {
        if (ctx.rootState.account.id != null && ctx.rootState.account.refreshToken != null) {
            return callApiWithRefresh(
                () => ctx.rootState.account.accessToken,
                () => ctx.dispatch('account/_refreshToken', null, { root: true }),
                (token) => API.getCoupon(token)
            )
        } else {
           return new Promise.reject("not login")
        }
    },
    registerCoupon(ctx, { code, force }) {
        return callApiWithRefresh(
            () => ctx.rootState.account.accessToken,
            () => ctx.dispatch('account/_refreshToken', null, { root: true }),
            (token) => API.registerCoupon(token, code, force)
        )
    },
    deleteCoupon(ctx) {
        return callApiWithRefresh(
            () => ctx.rootState.account.accessToken,
            () => ctx.dispatch('account/_refreshToken', null, { root: true }),
            (token) => API.deleteCoupon(token)
        )
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
